<template>
  <div class="modal fade" id="templateModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Vorlage wahlen</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form v-on:submit.prevent="setSelectedTemplate">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <select class="form-control mb-2 w-100" id="temp" v-model="selectedTemplate" required>
                  <option value="" disabled>Vorlage wahlen</option>
                  <option v-for="(temp, index) in templates" :key="index" :value="temp">
                    {{ temp.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="dokubtns text-right border-0">
            <span class="btninner">
              <button type="button" class="btn btn-red" data-dismiss="modal">
                Abbrechen
              </button>
              <button type="submit" class="btn btn-blue">
                Importieren
              </button>
            </span>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      selectedTemplate: '',
    }
  },
  mounted () {

  },
  computed: {
    templates () {
      return this.$store.state.appSettings.userTemplates
    },

    params :{
      get(){
        return this.$store.state.appSettings.project.params || [];
      },set(val){
        this.$store.commit("setProjectParams",val)
      }
    },
    project(){
      return this.$store.state.appSettings.project
    },
  },

  methods: {
    setSelectedTemplate () {
     this.$store.commit('settingsModuleSetLoading',true);
      this.params = this.selectedTemplate.params
      this.project.photoquality = this.selectedTemplate.photoquality
      this.project.dailydocu = this.selectedTemplate.dailydocutype
      $('#templateModal').modal('toggle');
     this.$store.commit('settingsModuleSetLoading',false);
     this.$toast.success('Vorlage erfolgreich implementiert');
    }
  }
}
</script>

<style scoped>
#templateModal .modal-dialog {
  max-width: 30%;
}

#templateModal select, #templateModal input {
  font-size: 1.04rem;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/TemplatesModal.vue